type ExpiryDuration = {
  draft:number;
  hledraft:number;
  endorsement:number;
  payment:number;
  hdb_review:number;
  extended_hdb_review:number;
  trackerStageB: number;
  trackerStageD: number;
};

let expiryDuration: ExpiryDuration = {
  draft: 28,
  hledraft: 42,
  endorsement: 7,
  payment: 7,
  hdb_review: 14,
  extended_hdb_review: 28,
  trackerStageB: 7,
  trackerStageD: 60,
};

export default expiryDuration;
